import { __decorate } from "tslib";
import { Route, Versioning } from '../core';
import config from '../config';
var EShop = /*@__PURE__*/ (function () {
    function EShop() {
    }
    EShop.get = function (response) {
        return response;
    };
    EShop = __decorate([
        Versioning(),
        Route(config.ESHOP_JSON_URL, config.ESHOP_JSON_URL.indexOf('http') > -1)
    ], EShop);
    return EShop;
}());
export { EShop };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/eshop.ts
// module id = null
// module chunks = 